import {
  ENQUIRY_CREATE_REQUEST, ENQUIRY_CREATE_SUCCESS, ENQUIRY_CREATE_FAIL,
  ENQUIRY_LIST_REQUEST, ENQUIRY_LIST_SUCCESS, ENQUIRY_LIST_FAIL,
} from '../constants/enquiryConstants';

export const enquiryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ENQUIRY_CREATE_REQUEST: return { loading: true };
    case ENQUIRY_CREATE_SUCCESS: return { loading: false, created: action.payload };
    case ENQUIRY_CREATE_FAIL:    return { loading: false, error: action.payload };
    default: return state;
  }
};

export const enquiryListReducer = (state = { items: [], page: 1, pages: 1, total: 0 }, action) => {
  switch (action.type) {
    case ENQUIRY_LIST_REQUEST: return { loading: true, items: [] };
    case ENQUIRY_LIST_SUCCESS: return { loading: false, ...action.payload };
    case ENQUIRY_LIST_FAIL:    return { loading: false, error: action.payload, items: [] };
    default: return state;
  }
};
